import { companyApi } from '../lib/api.ts';
import { LibraryView } from '../components/LibraryView.tsx';

export function CompanyLibrary() {
  return <LibraryView api={companyApi} basePath="/api/me/library" queryKey={['me', 'library']} />;
}
